<template>
    <div class="app__page-wrapper | u-padding-narrow">
        Todo
    </div>
</template>

<script>
export default {};
</script>
